import React from 'react';
import BaseForm from '../../../../../components/form/BaseForm/BaseForm';
import { PRODUCT_DETAIL_PAGE_PANEL_NAME } from '../../../../../constants/service/app/productConstants';
import { compareProductVersion } from '../../../../../lib/utils';
import ProductDetailPanel from '../../ProductDetailPanel';

const ProductExternalChannel = (props) => {
  const { initialValue, isCompare, comparisonData, ...res } = props;
  return (
    <ProductDetailPanel
      name={PRODUCT_DETAIL_PAGE_PANEL_NAME.PRO_EXTERNAL_CHANNEL}
      title="외부채널"
      isCompare={isCompare}
      {...res}
    >
      <div className="panel-body">
        <BaseForm
          label={'사방넷 전송'}
          className={compareProductVersion(initialValue, comparisonData)}
          content={initialValue ? '전송' : '전송 안함'}
        />
      </div>
    </ProductDetailPanel>
  );
};

export default ProductExternalChannel;
